import classnames from 'classnames/bind';
import { PropsWithChildren } from 'react';
import { EAnalyticsEvents } from '@/_analytic/_types';
import { getAnalyticsViewAttr } from '@/_analytic/_utils/get-analytics-view-attr/get-analytics-view-attr';
import styles from './index.module.scss';

const BLOCK_NAME = 'Footer';
const cn = classnames.bind(styles);

export const Footer = ({ children }: PropsWithChildren) => {
  return (
    <footer
      className={cn(BLOCK_NAME)}
      {...getAnalyticsViewAttr({
        name: EAnalyticsEvents.CATEGORIES_FOOTER_VIEW,
      })}
    >
      <div className={cn(`${BLOCK_NAME}__wrapper`)}>{children}</div>
    </footer>
  );
};
